import { render, staticRenderFns } from "./MessageTail.vue?vue&type=template&id=7b176544&"
import script from "./MessageTail.vue?vue&type=script&lang=js&"
export * from "./MessageTail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports